import { styled } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import Grid from "@mui/material/Grid";
import Switch from "@mui/material/Switch";
import Guid from "_shared/guids/guid";
import {
  getIndividualByUserId,
  getIndividualsByUserIds,
} from "marketplace/individuals/_stores/individuals-redux-slice";
import { useGetIndividualsByUserIdsQuery } from "marketplace/individuals/_api/individual-api";
import { useSelector } from "react-redux";
import { Masked, MaskedTeam } from "work/_shared/masked-fields";
import { HeadControls } from "work/_views/work-page-styled-components";
import VendorTeamReadOnly from "work/work-agreements/teams/vendor-team/_views/vendor-team-readonly-view";
import WorkAgreement from "work/work-agreements/work-agreement";

const ListContainer = styled(Grid)(() => ({
  minHeight: "20rem",
}));
const TeamReview = styled(VendorTeamReadOnly)(({ theme }) => ({
  [theme.breakpoints.down("lg")]: {
    marginTop: theme.spacing(2),
  },
  marginLeft: theme.spacing(2),
}));

type TeamTabProps = {
  workAgreement: WorkAgreement;
};

export default function TeamTab(props: Readonly<TeamTabProps>) {
  const { workAgreement } = props;

  const leaderUserId = MaskedTeam.isNotMasked(workAgreement.vendorTeam)
    ? workAgreement.vendorTeam?.leader?.userId
    : undefined;
  const leaderIndividual = useSelector(getIndividualByUserId(leaderUserId));
  const memberUserIds = MaskedTeam.isNotMasked(workAgreement.vendorTeam)
    ? workAgreement.vendorTeam?.members?.map((member) => member.userId).filter((id) => id !== undefined) ?? []
    : [];
  const memberIndividuals = useSelector(getIndividualsByUserIds(memberUserIds));

  const allUserIds = [...memberUserIds, leaderUserId].filter(Boolean) as Guid[];
  useGetIndividualsByUserIdsQuery(
    { userIds: new Set(allUserIds.map((id) => id.value)) },
    { skip: allUserIds.length === 0 },
  );

  if (Masked.isMasked(workAgreement.vendorTeam) || Masked.isMasked(workAgreement.teamRestricted)) {
    return "You do not have permission to view the team for this work agreement.";
  }

  return (
    <>
      <HeadControls>
        <FormControlLabel
          checked={workAgreement.teamRestricted.value}
          control={<Switch disabled={true} color="primary" />}
          label={workAgreement.teamRestricted.value ? <strong>Team Restricted</strong> : "Team Not Restricted"}
        />
      </HeadControls>
      <ListContainer container direction="row">
        <Grid size="grow">
          <TeamReview leader={leaderIndividual ?? null} members={memberIndividuals} hideCommentButton={true} />
        </Grid>
      </ListContainer>
    </>
  );
}
